import { apiClient, clearCsrfToken } from '@/lib/api/client';
import type {
  User,
  SingleResponse,
  MessageResponse,
} from '../types';
import type {
  LoginInput,
  RegisterInput,
  ForgotPasswordInput,
} from '../schemas';

const AUTH_BASE = '/api/v1/auth';

export function getMe(signal?: AbortSignal): Promise<SingleResponse<User>> {
  return apiClient.get<SingleResponse<User>>(`${AUTH_BASE}/me`, { signal });
}

export function login(data: LoginInput): Promise<SingleResponse<User>> {
  return apiClient.post<SingleResponse<User>>(`${AUTH_BASE}/login`, { body: data });
}

export function register(data: RegisterInput): Promise<SingleResponse<User>> {
  return apiClient.post<SingleResponse<User>>(`${AUTH_BASE}/register`, { body: data });
}

export async function logout(): Promise<MessageResponse> {
  const result = await apiClient.post<MessageResponse>(`${AUTH_BASE}/logout`);
  clearCsrfToken();
  return result;
}

export async function logoutAll(): Promise<MessageResponse> {
  const result = await apiClient.post<MessageResponse>(`${AUTH_BASE}/logout-all`);
  clearCsrfToken();
  return result;
}

export function verifyEmail(token: string): Promise<MessageResponse> {
  return apiClient.post<MessageResponse>(`${AUTH_BASE}/verify-email`, { body: { token } });
}

export function resendVerification(email: string): Promise<MessageResponse> {
  return apiClient.post<MessageResponse>(`${AUTH_BASE}/resend-verification`, { body: { email } });
}

export function forgotPassword(data: ForgotPasswordInput): Promise<MessageResponse> {
  return apiClient.post<MessageResponse>(`${AUTH_BASE}/forgot-password`, { body: data });
}

export function resetPassword(data: { token: string; password: string }): Promise<MessageResponse> {
  return apiClient.post<MessageResponse>(`${AUTH_BASE}/reset-password`, { body: data });
}
